import { useQueryParams } from 'hooks/environment/useQueryParams';
import { usePrevious } from 'hooks/usePrevious';
import { useEffect, useMemo } from 'react';

interface Args {
  scrollRef: any;
  paramName?: string;
}

export const useScrollToTopOnParamChange = ({ paramName = '', scrollRef }: Args) => {
  const name = useMemo(() => paramName, [paramName]);
  const { params } = useQueryParams();
  const prevParam = usePrevious(params?.[name]);

  useEffect(() => {
    if (prevParam !== params[name]) {
      // Hacky way to allow the component to render on the new param before scrolling to top
      setTimeout(() => {
        if (scrollRef.current && scrollRef.current.scrollIntoView) {
          scrollRef.current.scrollIntoView({
            block: 'start',
            behavior: 'auto',
          });
        }
      }, 1);
    }
  }, [name, params, prevParam, scrollRef]);
};
